import React, {Component} from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import './index.scss';

export default class OptionToggle extends Component {
    constructor(props) {
        super(props);
        this.state = {selected: props.selected};
    }

    onSelect(id, onSelect) {
        this.setState({selected: id});
        if (onSelect) {
            onSelect(id);
        }
    }

    renderOption = ({id, iconComponent: Icon, onSelect}) => {
        const {selected} = this.state;
        const isSelected = id === selected;
        const classes = classNames('option-toggle__option', {
            'option-toggle__option--selected': isSelected
        });
        return (
            <span key={id} className={classes} onClick={() => this.onSelect(id, onSelect)}>
                <Icon/>
            </span>
        );
    };

    render() {
        const {options} = this.props;
        return <div className="option-toggle">{R.map(this.renderOption, options)}</div>;
    }
}



// WEBPACK FOOTER //
// ./components/option_toggle/index.js